import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import styles from './AppointmentHistory.module.sass'
import { useMemo } from 'react'

const AppointmentHistory = (props) => {
	const { data, ...attributes } = props

	const mappedHistory = useMemo(
		() =>
			data?.history ? (
				<>
					<h5>{data.$cardLabels?.history}</h5>
					{data.history.map((item) => (
						<VStack key={item?.id}>
							<VStack
								className={styles['history-line-container']}
							>
								<HStack
									className={styles['history-line-title']}
								>
									<span
										className={
											styles['history-item-circle']
										}
									></span>
									<h5>
										{item?.modificationDate?.dateTimeFormat}
										, {item?.modificationUser}
									</h5>
								</HStack>
								<small>{item?.observations}</small>
							</VStack>
						</VStack>
					))}
				</>
			) : (
				''
			),
		[data.history, data.$cardLabels.history]
	)

	return (
		<div {...attributes} className={styles['history-container']}>
			{mappedHistory}
		</div>
	)
}

export default AppointmentHistory
